<body class="dashboard dashboard-bg superadmin-dashboard">
  <app-header></app-header>

  <div class="body-container collapsed">
    <app-sidebar></app-sidebar>

    <div class="body-content">
      <app-progress-spinner [show]="isLoading"></app-progress-spinner>

      <div class="row">
        <div class="col p-0">
          <!-- <app-chart-header [itemId]="sensorId" [items]="sensors" iconClass="fas fa-broadcast-tower"
        (selectionChanged)="switchSensor($event)"></app-chart-header> -->
      </div>
    </div>

    <div class="row mt-2 device-status">
      <div class="col-auto ml-auto">
        <mat-label>
          <span class="text-muted">{{ 'Status as of:' | translate }}</span>
          {{sensorRecord.timestamp ? (sensorRecord.timestamp | dateFormat) : ('Never' | translate)}}
        </mat-label>
      </div>
    </div>
    @if (sensorType && (isNoiseTimeseries || isAirNowMonitoring || isGasData)) {
      <div
        class="row mt-4 device-status">
        <div class="col-sm-auto ml-auto"></div>
        @if (isNoiseTimeseries) {
          <div class="col-sm-auto">
            <mat-label>
              <span class="text-muted">{{ 'Avg Sound Level:' | translate }}</span>
              {{sensorRecord.lavg !== undefined ? (sensorRecord.lavg | number:'1.0-2') : '-'}} db
            </mat-label>
          </div>
        }
        @if (isAirNowMonitoring) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">{{ 'Ozone:' | translate }}</span>
              {{sensorRecord.ozone !== undefined ? (sensorRecord.ozone | number:'1.0-2') : '-'}} PPB
            </mat-label>
          </div>
        }
        @if (isAirNowMonitoring) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">NO2:</span>
              {{sensorRecord.nO2 !== undefined ? (sensorRecord.nO2 | number:'1.0-2') : '-'}} PPB
            </mat-label>
          </div>
        }
        @if (isAirNowMonitoring) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">SO2:</span>
              {{sensorRecord.sO2 !== undefined ? (sensorRecord.sO2 | number:'1.0-2') : '-'}} PPB
            </mat-label>
          </div>
        }
        @if (isAirNowMonitoring) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">CO:</span>
              {{sensorRecord.co !== undefined ? (sensorRecord.co | number:'1.0-2') : '-'}} PPM
            </mat-label>
          </div>
        }
        @if (isGasData) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">CO2:</span>
              {{sensorRecord.cO2 !== undefined ? (sensorRecord.cO2 | number:'1.0-2') : '-'}} PPM
            </mat-label>
          </div>
        }
        @if (isGasData) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">{{ 'TVOC:' | translate }}</span>
              {{sensorRecord.tvoc !== undefined ? (sensorRecord.tvoc | number:'1.0-2') : '-'}} PPM
            </mat-label>
          </div>
        }
      </div>
    }
    @if (sensorType && isParticulateOrOpcR2OrAirNow) {
      <div
        class="row mt-4 device-status">
        <div class="col-sm-auto ml-auto"></div>
        @if (isParticulateOrOpcR2) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">PM1.0:</span>
              {{sensorRecord.pm1 !== undefined ? (sensorRecord.pm1 | number:'1.0-2') : '-'}}
              {{pmUnit}}
            </mat-label>
          </div>
        }
        @if (isParticulateOrOpcR2OrAirNow) {
          <div class="col-sm-auto">
            <mat-label>
              <span class="text-muted">PM2.5:</span>
              {{sensorRecord.pm2_5 !== undefined ? (sensorRecord.pm2_5 | number:'1.0-2') : '-'}}
              {{pmUnit}}
            </mat-label>
          </div>
        }
        @if (isParticulateOrOpcR2OrAirNow) {
          <div class="col-sm-auto">
            <mat-label>
              <span class="text-muted">PM10.0</span>
              {{sensorRecord.pm10 !== undefined ? (sensorRecord.pm10 | number:'1.0-2') : '-'}}
              {{pmUnit}}
            </mat-label>
          </div>
        }
        @if (isParticulateOrOpcR2) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">{{ 'Respirable PM:' | translate }}</span>
              {{sensorRecord.respirablePm !== undefined ? (sensorRecord.respirablePm | number:'1.0-2') : '-'}}
              {{pmUnit}}
            </mat-label>
          </div>
        }
        @if (isParticulateOrOpcR2) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">{{ 'Temperature:' | translate }}</span>
              {{sensorRecord.tempC !== undefined ? (sensorRecord.tempC | number:'1.0-2') : '-'}}
              {{temperatureUnit}}
            </mat-label>
          </div>
        }
        @if (isParticulateOrOpcR2) {
          <div
            class="col-sm-auto">
            <mat-label>
              <span class="text-muted">{{ 'Humidity:' | translate }}</span>
              {{sensorRecord.hum !== undefined ? (sensorRecord.hum | number:'1.0-2') : '-'}} %
            </mat-label>
          </div>
        }
        @if (isParticulateOrOpcR2) {
          <div
            class="col-auto mr-5">
            <mat-icon class="mr-4">
              <img style="width: 30px; height: 24px; vertical-align: baseline;" [src]="icon">
            </mat-icon>
            <mat-icon>
              <i [class]="batteryPercentageClass"></i>
              <span class="ml-2">
                {{sensorRecord.batteryPercentage !== undefined ? sensorRecord.batteryPercentage : '-'}} %
              </span>
            </mat-icon>
          </div>
        }
      </div>
    }

    <div class="row mt-5">
      <div class="col-md-auto pl-0">
        <div id="zoom-buttons">
          <button mat-button class="btn button-accent zoom-8h active ml-2 mt-3" (click)="zoom('8h')"
            [disabled]="isMapLoading">
            <mat-icon>
              <i class="fas fa-clock fa-sm"></i>
            </mat-icon>
            <div>8h</div>
          </button>
          <button mat-button class="btn button-primary zoom-3d ml-2 mt-3" (click)="zoom('3d')"
            [disabled]="isMapLoading">
            <mat-icon>
              <i class="fas fa-clock fa-sm"></i>
            </mat-icon>
            <div>3d</div>
          </button>
          <button mat-button class="btn button-primary zoom-1m ml-2 mt-3" (click)="zoom('1m')"
            [disabled]="isMapLoading">
            <mat-icon>
              <i class="fas fa-clock fa-sm"></i>
            </mat-icon>
            <div>1m</div>
          </button>
          <button mat-button class="btn button-primary zoom-all ml-2 mt-3" (click)="zoom('all')"
            [disabled]="isMapLoading">
            <mat-icon>
              <i class="fas fa-clock fa-sm"></i>
            </mat-icon>
            <div>{{ 'All' | translate }}</div>
          </button>
        </div>
      </div>

      <div class="col-md-3">
        <mat-form-field>
          <mat-label>{{ 'From Date' | translate }}</mat-label>
          <input matInput [(ngModel)]="fromDate" class="clickable" [owlDateTime]="dtStart"
            [owlDateTimeTrigger]="dtStart" required />
            <mat-icon matPrefix class="clickable mr-3" [owlDateTimeTrigger]="dtStart"
              >
              <i class="fas fa-calendar-alt"></i>
            </mat-icon>
            <mat-error>{{ 'From Date is required' | translate }}</mat-error>
            <owl-date-time #dtStart></owl-date-time>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'To Date' | translate }}</mat-label>
            <input matInput [(ngModel)]="toDate" class="clickable" [owlDateTime]="dtEnd"
              [owlDateTimeTrigger]="dtEnd" required />
              <mat-icon matPrefix class="clickable mr-3" [owlDateTimeTrigger]="dtEnd"
                >
                <i class="fas fa-calendar-alt"></i>
              </mat-icon>
              <mat-error>{{ 'To Date is required' | translate }}</mat-error>
              <owl-date-time #dtEnd></owl-date-time>
            </mat-form-field>
          </div>

          <div class="col-md-2">
            <mat-form-field>
              <mat-label>{{ 'Parameter(s)' | translate }}</mat-label>
              <mat-select [(ngModel)]="selectedParams" multiple required>
                @for (param of parameters; track trackById($index, param)) {
                  <mat-option [value]="param.id">
                    {{param.value}}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-chart-line"></i>
              </mat-icon>
              <mat-error>{{ 'Parameter is required' | translate }}</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <button class="btn button-secondary mt-3 mr-2" mat-button [class.button-spinner]="isMapLoading"
            (click)="search()" [disabled]="isDisabled() || isMapLoading">{{ 'Plot' | translate }}</button>

            <button class="btn button-primary-light mt-3 mb-3"
            mat-button (click)="export()" [disabled]="!fromDate || !toDate || isMapLoading">{{ 'Export' | translate }}</button>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8 p-0">
            <div class="row">
              <div class="col" (resized)="onResized($event)">
                <div [id]="CHART_DIV_ID" style="width: 100%; height: 800px;"></div>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="row">
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    @for (param of columnParameters; track trackByIndex($index)) {
                      <th>
                        {{param | mapLookup: paramNamesById}}
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{'Average' | translate}} [{{paramUnit}}]</td>
                    @for (param of columnParameters; track trackByIndex($index)) {
                      <td>
                        {{deviceAverage[param] | number:'1.0-2'}}
                      </td>
                    }
                  </tr>
                  <tr>
                    <td>{{'Peak' | translate}} [{{paramUnit}}]</td>
                    @for (param of columnParameters; track trackByIndex($index)) {
                      <td>
                        {{devicePeak[param] | number:'1.0-2'}}
                      </td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>

            @if (preferences.showMap) {
              <div class="row">
                <div class="col p-0">
                  <div class="google-map-device-detail" style="width: 100%; margin-top:25px"  >
                    <app-device-details-map-clusterer [loading]="true"></app-device-details-map-clusterer>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="row ml-3 mr-3" [hidden]="isVideoChartHidden">
          <div class="col-lg-8 pl-4 pr-4" (resized)="onVideoResized($event)">
            <div [id]="CHART_VIDEO_DIV_ID" style="width: 100%; height: 150px;"></div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8 p-0">
            @if (videoResource) {
              <app-lazy-video-player [videoResource]="videoResource"
                (onPlayerReadyEmit)="onPlayerReady($event)">
              </app-lazy-video-player>
            }
          </div>

          <div class="col-lg-3 offset-lg-1 p-0">
            <mat-form-field>
              <mat-label>{{ 'Time Zone' | translate }}</mat-label>
              <input matInput [(ngModel)]="timeZoneLabel" readonly />
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-globe"></i>
              </mat-icon>
            </mat-form-field>
            <div [hidden]="isVideoChartHidden" style="min-height: 70vh">&nbsp;</div>
          </div>
        </div>

        <div class="clearfix"></div>
        <app-footer></app-footer>
      </div>
    </div>
  </body>
